import { TranscoderSelector, TranscoderTask, TranscoderWorkerType } from '../../models';

const updateRtmpSelectors = (selectors: TranscoderSelector[], kind: 'audio' | 'video'): TranscoderSelector[] => {
  const updatedSelectors: TranscoderSelector[] = [];
  for (const selector of selectors) {
    updatedSelectors.push({
      index: selector.pid,
      mediaType: kind,
      pid: 0,
    } as TranscoderSelector);
  }

  return updatedSelectors;
};

const restorePidForRtmpSelectors = (selectors: TranscoderSelector[]) => {
  selectors.forEach((item: TranscoderSelector, index: number) => {
    item.pid = item.index;
    item.index = index;
  });
};

export const setRtmpValidPid = (task: TranscoderTask) => {
  if (task.input?.length > 0 && task.input[0].url.includes('rtmp')) {
    restorePidForRtmpSelectors(task.audioMap);
    restorePidForRtmpSelectors(task.videoMap);
  }
};

export const transformTaskRequest = (task: TranscoderTask): TranscoderTask => {
  const { multiOutput = false, ...newTask } = task;
  const isRtmpStream = task.input?.length > 0 && task.input[0].url.includes('rtmp');

  newTask.audioMap = isRtmpStream ? updateRtmpSelectors(task.audioMap, 'audio') : [...newTask.audioMap];
  newTask.videoMap = isRtmpStream ? updateRtmpSelectors(task.videoMap, 'video') : [...newTask.videoMap];

  if (multiOutput) {
    newTask.streams = task.streams.map(s => ({ ...s, format: 'mpegts' }));
  } else {
    newTask.streams = task.streams.slice(0, 1);
  }

  return newTask;
};

export const guessTranscoderWorkerType = (task: TranscoderTask): TranscoderWorkerType => {
  const { workerName = '' } = task;
  const workerTypeValue = workerName.split('-').slice(0, -1).join('-');
  return (
    Object.values(TranscoderWorkerType).find(value => value === workerTypeValue) ?? TranscoderWorkerType.All_In_One
  );
};
